import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addMinorCanabinoid, assignMinorCanabinoid, getProductMinorCanabinoids, getMinorCanabinoids, resetAssignMinorCanabinoidSuccess, resetAddMinorCanabinoid, deleteMinorCanabinoid, resetGetMinorCanabinoids, saveMinorCanabinoid } from 'actions/EntityActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import '../Styles/MoodTerpene.css';

class ProductMinorCanabinoid extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        this.props.productId ? this.props.getProductMinorCanabinoids(this.props.productId) : alert("Unable to retrieve MinorCanabinoids");
        this.props.getMinorCanabinoids();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.minorCanabinoidsSuccess != null && newProps.minorCanabinoidsSuccess != undefined && newProps.minorCanabinoidsSuccess != this.props.minorCanabinoidsSuccess && newProps.minorCanabinoidsSuccess) {
            this.props.productId ? this.props.getProductMinorCanabinoids(this.props.productId) : alert("Unable to retrieve MinorCanabinoids");
            this.props.resetAssignMinorCanabinoidSuccess();
        }
        if (newProps.addMinorCanabinoidSuccess != null && newProps.addMinorCanabinoidSuccess != undefined && newProps.addMinorCanabinoidSuccess != this.props.addMinorCanabinoidSuccess && newProps.addMinorCanabinoidSuccess) {
            this.props.getMinorCanabinoids();
            this.props.resetAddMinorCanabinoid();
            this.props.clearFormInput("ProductMinorCanabinoidAddMinorCanabinoidName");
            this.props.clearFormInput("ProductMinorCanabinoidAddMinorCanabinoidAbbreviation");
        }
        if (newProps.productMinorCanabinoids != null && newProps.productMinorCanabinoids != undefined && newProps.productMinorCanabinoids != this.props.productMinorCanabinoids && newProps.productMinorCanabinoids.length > 0) {
            (newProps.productMinorCanabinoids).map((item) => {
                if(this.props.form[`ProductMinorCanabinoid_${item.id}_Min`] == undefined || this.props.form[`ProductMinorCanabinoid_${item.id}_Min`] == null) {
                    this.props.formInput((item.min * 100).toFixed(2), `ProductMinorCanabinoid_${item.id}_Min`);
                    if(item.min==0) this.props.formInput("0", `ProductMinorCanabinoid_${item.id}_Min`);
                }
                if(this.props.form[`ProductMinorCanabinoid_${item.id}_Max`] == undefined || this.props.form[`ProductMinorCanabinoid_${item.id}_Max`] == null) {
                    this.props.formInput((item.max * 100).toFixed(2), `ProductMinorCanabinoid_${item.id}_Max`);
                    if(item.max==0) this.props.formInput("0", `ProductMinorCanabinoid_${item.id}_Max`);
                }
            });
        }
    }

    componentWillUnmount() {
        let p = this.props;
        p.productMinorCanabinoids.map((item) => {
            this.props.clearFormInput(`ProductMinorCanabinoid_${item.id}_Min`);
            this.props.clearFormInput(`ProductMinorCanabinoid_${item.id}_Max`);
        });
    }

    addMinorCanabinoid = () => {
        let minorCanabinoidName = this.props.addMinorCanabinoidName;
        let validMinorCanabinoid = new RegExp('^[A-Za-z0-9]');
        if (minorCanabinoidName && !validMinorCanabinoid.test(minorCanabinoidName)) {
            alert("Minor Canabinoid Name cannot contain symbols");
            return;
        }
        let minorCanabinoidAbbreviation = this.props.addMinorCanabinoidAbbreviation;
        if (minorCanabinoidAbbreviation && !validMinorCanabinoid.test(minorCanabinoidAbbreviation)) {
            alert("Minor Canabinoid Abbreviation cannot symbols");
            return;
        }
        this.props.addMinorCanabinoid(minorCanabinoidName, minorCanabinoidAbbreviation, this.props.branchId);
    }

    addProductMinorCanabinoid = (minorCanabinoidId) => {
        if (!minorCanabinoidId === parseInt(minorCanabinoidId) || !(this.props.productId)) {
            alert("Unable to assign minorCanabinoid to product");
            return;
        }
        this.props.assignMinorCanabinoid(this.props.productId, minorCanabinoidId);
    }

    deleteProductMinorCanabinoid = (minorCanabinoidId) => {
        if (!minorCanabinoidId === parseInt(minorCanabinoidId) || !(this.props.productId)) {
            alert("Unable to un-assign MinorCanabinoid");
            return;
        }
        this.props.clearFormInput(`ProductMinorCanabinoid_${minorCanabinoidId}_Min`);
        this.props.clearFormInput(`ProductMinorCanabinoid_${minorCanabinoidId}_Max`);
        this.props.deleteMinorCanabinoid(this.props.productId, minorCanabinoidId);
    }

    saveMinorCanabinoids = () => {
        let p = this.props;
        p.productMinorCanabinoids.map((item) => {
            if(p.form[`ProductMinorCanabinoid_${item.id}_Min`] < 0 || p.form[`ProductMinorCanabinoid_${item.id}_Min`] > 100 || p.form[`ProductMinorCanabinoid_${item.id}_Min`] == undefined || p.form[`ProductMinorCanabinoid_${item.id}_Min`] == null ||
            p.form[`ProductMinorCanabinoid_${item.id}_Max`] < 0 || p.form[`ProductMinorCanabinoid_${item.id}_Max`] > 100 || p.form[`ProductMinorCanabinoid_${item.id}_Max`] == undefined || p.form[`ProductMinorCanabinoid_${item.id}_Max`] == null)
            {
                alert("Please assign all MinorCanabinoid Min/Max, cannot be greater then 100");
                return;
            }
            let min = parseFloat(p.form[`ProductMinorCanabinoid_${item.id}_Min`]) / 100.0;
            let max = parseFloat(p.form[`ProductMinorCanabinoid_${item.id}_Max`]) / 100.0;
            if (min != item.min || max != item.max) {
                this.props.saveMinorCanabinoid(item.id, item.productId, min, max);
            }
        });
    }

    render() {
        const p = this.props;
        let minorCanabinoids = p.minorCanabinoids;

        return (
            <React.Fragment>
                <div className="row" >
                    {/* LEFT PANEL */}
                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-0">
                        <div className="row">
                            {/* NEW MINOR CANABINOID */}
                            <div className="col-lg-12 col-md-12 col-sm-12 pb-2 pt-0 mt-0">
                                <TextInput
                                    name={`ProductMinorCanabinoidAddMinorCanabinoidName`}
                                    fullWidth={true}
                                    label={"Canabinoid Name"}
                                    floatingLabelText={"Canabinoid Name"}
                                    hintText={"Canabinoid Name"}
                                    className="pb-0 mb-0 pt-0 mt-0"
                                    style = {{marginTop:`5px`}}
                                    required />
                                <TextInput
                                    name={`ProductMinorCanabinoidAddMinorCanabinoidAbbreviation`}
                                    fullWidth={true}
                                    label={"Canabinoid Abbreviation"}
                                    floatingLabelText={"Canabinoid Abbreviation"}
                                    hintText={"Canabinoid Abbreviation"}
                                    className="pb-0 mb-0 pt-0 mt-0"
                                    style = {{paddingTop:`5px`}}
                                    required />
                                <Button
                                    type="AddButton"
                                    label="SAVE NEW CANABINOID"
                                    primary={true}
                                    onTouchTap={() => this.addMinorCanabinoid()} />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pl-0 ml-0" style={{ overflowX: `hide`, maxHeight: `500px`, overflowY: `scroll` }}>
                            {
                                !minorCanabinoids || minorCanabinoids.length == 0 ? <h4>No MinorCanabinoids created</h4> :
                                    minorCanabinoids.map((item) => {
                                        return (
                                            <h6 className="moodListItem"><span>{item.abbreviation} - {item.name}</span> <Button style={{minWidth: `25px`, height: `25px`}} type="IconAdd" onTouchTap={() => this.addProductMinorCanabinoid(item.id)} /></h6>
                                        )
                                    }
                                    )
                            }
                        </div>
                    </div>
                    {/* RIGHT PANEL */}
                    <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                        <h5>{p.propProductName ? p.propProductName: p.productName}</h5>
                        <h6 className="pb-3">{p.propProductSKU ? p.propProductSKU : p.productSKU }</h6>
                        <h6 className="pb-2"><u>Assigned Minor Canabinoids</u></h6>
                                {
                                    !p.productMinorCanabinoids || p.productMinorCanabinoids.length == 0 ? <h4>No Minor Canabinoids Assigned</h4> :
                                        p.productMinorCanabinoids.map((item) => {
                                            return (
                                                <div className='row'>
                                                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-3 p-0 terpene-name">{item.abbreviation} - {item.name}</div>
                                                    <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 p-0 d-flex align-items-center">
                                                        <span className="mr-1 minText">Min%:</span>
                                                        <DecimalInput hintText="%" name={`ProductMinorCanabinoid_${item.id}_Min`} className="TerpeneNumberInput" />
                                                    </div>
                                                    <div className="col-xs-3 col-sm-3 col-md-3 col-lg-4 col-xl-4 p-0 d-flex align-items-center">
                                                        <span className="mr-1 maxText">Max%:</span>
                                                        <DecimalInput hintText="%" name={`ProductMinorCanabinoid_${item.id}_Max`} className="TerpeneNumberInput" />
                                                    </div>
                                                    <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                                                        <Button style={{ minWidth: `25px`, height: `25px` }} type="IconDeleteButton" onTouchTap={() => this.deleteProductMinorCanabinoid(item.id)} />
                                                    </div>
                                                </div>)
                                            }
                                        )
                                }
                            </div>
                        </div>
                    <div style={{paddingBottom: `40px`}}>
                        <Button
                            name="SaveButton"
                            className="pull-right mt-2"
                            label="SAVE RANGES"
                            primary={true}
                            onTouchTap={() => this.saveMinorCanabinoids()} />
                        <Button
                            type="Button"
                            label="CANCEL"
                            primary={true}
                            className="pull-right mt-2 mr-1"
                            onTouchTap={() => this.props.onCancel()} />
                    </div>
            </React.Fragment>
        );
    }
}

function mapStatetoProps(state, props) {
    return {
        addMinorCanabinoidName: state.form["ProductMinorCanabinoidAddMinorCanabinoidName"],
        addMinorCanabinoidAbbreviation: state.form["ProductMinorCanabinoidAddMinorCanabinoidAbbreviation"],
        branchId: state.common.branchId,
        minorCanabinoids: state.entity.minorCanabinoids,
        productMinorCanabinoids: state.entity.productMinorCanabinoids,
        minorCanabinoidsSuccess: state.entity.minorCanabinoidsSuccess || false,
        addMinorCanabinoidSuccess: state.entity.addMinorCanabinoidSuccess || false,
        productName: state.form[props.pageName + "Name"] || "Unable to retrieve Product Name",
        productSKU: state.form[props.pageName + "SKU"] || "",
        getMinorCanabinoidsSuccess: state.entity.getMinorCanabinoidsSuccess || false,
        form: state.form
    };
}

function mapDispatchToProps(dispatch, props) {
    return {
        addMinorCanabinoid: (name, branchId) => dispatch(addMinorCanabinoid(name, branchId)),
        assignMinorCanabinoid: (productId, minorCanabinoidId) => dispatch(assignMinorCanabinoid(productId, minorCanabinoidId)),
        getProductMinorCanabinoids: (productId) => dispatch(getProductMinorCanabinoids(productId)),
        getMinorCanabinoids: () => dispatch(getMinorCanabinoids()),
        resetAssignMinorCanabinoidSuccess: () => dispatch(resetAssignMinorCanabinoidSuccess()),
        deleteMinorCanabinoid: (productId, minorCanabinoidId) => dispatch(deleteMinorCanabinoid(productId, minorCanabinoidId)),
        resetAddMinorCanabinoid: () => dispatch(resetAddMinorCanabinoid()),
        resetGetMinorCanabinoids: () => dispatch(resetGetMinorCanabinoids()),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        saveMinorCanabinoid: (minorCanabinoidId, productId, min, max) => dispatch(saveMinorCanabinoid(minorCanabinoidId, productId, min, max))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(ProductMinorCanabinoid);
